import fetchAPI from '../fetchAPI';

export interface SupportTicketItem {
  id: string;
  userId: string;
  companyId: string | null;
  userEmail: string | null;
  subject: string;
  description: string;
  diagnostics: {
    extensionVersion?: string;
    waWebVersion?: string | null;
    waWebBuild?: string | null;
    userAgent?: string;
    online?: boolean;
    env?: string;
    /** "SR-7F3K2Q" — the diagnostics report sent with the ticket. */
    referenceCode?: string;
    /** The extension's Help-flow run this ticket came from. */
    helpSessionId?: string;
  } | null;
  submittedAt: string;
  createdAt: string;
  /** Help-flow steps linked to this ticket (`ExtensionEvents`), oldest first. */
  steps?: SupportTicketStep[];
}

export interface SupportTicketStep {
  event: string;
  occurredAt: string;
  data: Record<string, unknown> | null;
}

/** Plain names for the extension's step events (server routes/extensionEvents.ts). */
export const STEP_LABEL: Record<string, string> = {
  help_opened: 'Help opened',
  snapshot_sent: 'Snapshot sent',
  cache_cleared: 'Cache cleared',
  logged_out: 'Logged out',
  refreshed: 'Refreshed',
  signed_in: 'Signed in',
  ticket_sent: 'Ticket sent'
};

export interface SupportTicketsResponse {
  data: SupportTicketItem[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  pageCount: number;
  totalPageCount: number;
}

const callGetSupportTickets = async (
  page = 1,
  pageSize = 25
): Promise<iResponse<SupportTicketsResponse>> => {
  const qs = `page=${page}&pageSize=${pageSize}`;
  return fetchAPI<SupportTicketsResponse>({
    method: 'GET',
    route: `ext/support-ticket`,
    queryString: qs
  });
};

export default callGetSupportTickets;
